module.exports = __webpack_public_path__ + "media/images/front/knowledge_note/knowledge_note_banner-edf511abee66609ef791de8b9d1921ac.png";